export default class ApplicationLinks {
    constructor() {
        this.isCarousel = !!document.querySelector('.js-carousel')
        this.applicationLinks = document.querySelector('.js-application-links')
        this.addApplicationLinksWithCalculatorClass()
    }

    addApplicationLinksWithCalculatorClass() {
        if (this.isCarousel && this.applicationLinks) {
            this.applicationLinks.classList.add('application-links--carousel')
        }
    }
}
